import { newDateFromUTC, newDateToUTC } from '@bc-library/common'
import { afterReceivingOne as afterReceivingOneResource } from '@/services/resource/hooks'


// DATA RECEIVED FOM API (FROM UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const afterReceiving = (data:any) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
     return afterReceivingOne(object);
   })
  }
  else if(data.docs && data.count && Array.isArray(data.docs)){
    data.docs = data.docs.map((object:any) => {
      return afterReceivingOne(object);
    })
  }
  else if(typeof data == 'object'){
    data = afterReceivingOne(data);
  }
  return data;
};

export const afterReceivingMailHashTagsInfo = (data:any) => {
  if (!data || typeof data !== 'object')
    return data

  return {
    ...data,
    hashTag: data.hashTag && afterReceivingOne(data.hashTag),
  }
}

const afterReceivingEmployeeOnboardingResource = (resource:any) => {
  if (!resource || typeof resource !== 'object')
    return null

  return {
    ...afterReceivingOneResource(resource),
  }
}

const afterReceivingActionAssignee = (resource:any) => {
  if (!resource || typeof resource !== 'object' || Array.isArray(resource))
    return resource

  if (resource.firstname == null && resource.lastname == null && resource.picture == null)
    return resource

  return afterReceivingEmployeeOnboardingResource(resource)
}

const afterReceivingOnboardingSteps = (steps:any) => {
  if (!Array.isArray(steps))
    return steps

  return steps.map((step:any) => ({
    ...step,
    actions: Array.isArray(step?.actions)
      ? step.actions.map((action:any) => ({
          ...action,
          resource: afterReceivingActionAssignee(action.resource),
          mailResponsibleResource: afterReceivingActionAssignee(action.mailResponsibleResource),
        }))
      : step.actions,
  }))
}

const afterReceivingActionProcess = (process:any) => {
  if (!process || typeof process !== 'object')
    return process

  return {
    ...process,
    resource: afterReceivingEmployeeOnboardingResource(process.resource),
  }
}

// SINGLE OBJECT
export const afterReceivingOne = (object:any) => {
  if(typeof object == 'object'){
    const resource = afterReceivingEmployeeOnboardingResource(object.resource);
    const rawActionDate = object.actionDate ? newDateFromUTC(object.actionDate) : null;
    
    let actionDate = rawActionDate;
    if (resource) {
      if (object.isOnboarding) {
        actionDate = resource.recruitmentDate || rawActionDate;
      } else {
        actionDate = resource.departureDate || rawActionDate;
      }
    }

    return {
      ...object,
      _created: object._created && new Date(object._created),
      actionDate,
      resource,
      steps: afterReceivingOnboardingSteps(object.steps),
      ...(object.process && typeof object.process === 'object' ? { process: afterReceivingActionProcess(object.process) } : {}),
    }
  }
  return object;
}

// OBJECT FIELDS






// DATA TO BE SENT TO API (TO UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const beforeSending = (data:any) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
      return beforeSendingOne(object);
    })
  }
  else if(typeof data == 'object'){
    data = beforeSendingOne(data);
  }
  return data;
};

// SINGLE OBJECT
export const beforeSendingOne = (object:any) => {
  if(typeof object == 'object'){
    return {
      ...object,
      startDate: object.startDate && newDateToUTC(object.startDate),
      endDate: object.endDate && newDateToUTC(object.endDate),
      actionDate: object.actionDate && newDateToUTC(object.actionDate),
    }
  }
  return object;
}

// OBJECT FIELDS


